module.exports = __webpack_public_path__ + "static/media/linked-in-black.3bd6c407.svg";